module.exports = __webpack_public_path__ + "img/coupon-unprogress-custom.4e7605a4.png";